import { Box, Fab, List, ListItem, Stack, styled } from '@mui/material'
import { getModalStyle } from '../../../utils'

export const StyledListItem = styled(ListItem)(({ theme }) => ({
  flexWrap: 'wrap',
  padding: 0,
  '& .MuiListItemText-primary': {
    ...theme.typography.subtitle2,
    color: '#595959',
  },
  '& .MuiListItemText-secondary': {
    ...theme.typography.body1,
    color: '#000',
  },
}))

export const StyledList = styled(List)(({ theme }) => ({
  padding: 0,
  marginBottom: theme.spacing(3),
}))

export const BtnCloseModal = styled(Fab)(({ theme }) => ({
  width: theme.spacing(3),
  height: theme.spacing(3),
  minHeight: 'auto',
  boxShadow: 'none',
  backgroundColor: 'transparent',
  '& .MuiSvgIcon-root': {
    width: theme.spacing(2.5),
    height: theme.spacing(2.5),
  },
}))

export const ModalHeader = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: theme.spacing(3, 3, 2, 3),
  borderBottom: '1px solid #ccc',
}))

export const StyledModalContainer = styled(Stack)(({ theme }) => ({
  ...getModalStyle(),
  maxWidth: theme.spacing(64),
  outline: 'none',
  position: 'absolute',
  width: '100%',
  backgroundColor: theme.palette.background.paper,
  boxShadow: theme.shadows[5],
  [theme.breakpoints.up('sm')]: {
    maxWidth: theme.spacing(64),
  },
  [theme.breakpoints.down('xs')]: {
    maxWidth: 'calc(328px - 32px)',
  },
}))

export const StyledModalBody = styled(Box)(({ theme }) => ({
  width: '100%',
  padding: theme.spacing(0, 3),
  margin: theme.spacing(3, 0),
  maxHeight: 'calc(100vh - 180px)',
  overflowY: 'auto',
  '& > .MuiBox-root': {
    width: '100%',
  },
}))
